/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { ContentInformationClassNames } from './ContentInformation';

function Subtitle({ className, darken, children }) {
  return (
    <p className={ContentInformationClassNames.element('subtitle', { darken }, className)}>
      {children}
    </p>
  );
}

Subtitle.propTypes = {
  className: PropTypes.string,
  darken: PropTypes.bool,
  children: PropTypes.node,
};

Subtitle.defaultProps = {
  className: '',
  darken: false,
  children: undefined,
};

export default memo(Subtitle);
